/* GRENADINE – pont panier pour le theme Horizon.
   Les fiches prestations, Meety et les anciens scripts ajoutent au panier en appelant
   directement /cart/add.js (ou change/update/clear). Horizon, lui, ne rafraichit son tiroir
   que pour ses propres actions. Ce pont surveille ces appels, puis :
   - recharge le contenu du tiroir panier (section "cart-drawer-section"),
   - met a jour le compteur de l'icone panier,
   - ouvre le tiroir apres un ajout. */
(function () {
  if (window.__grCartBridge) return;
  window.__grCartBridge = true;

  function isCartMutation(url) {
    if (typeof url !== 'string') url = (url && url.url) || '';
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }
  function isAdd(url) {
    if (typeof url !== 'string') url = (url && url.url) || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  var busy = null;
  function refresh(open) {
    if (busy) clearTimeout(busy);
    busy = setTimeout(function () {
      busy = null;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      _fetch(root + '?sections=cart-drawer-section&_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data['cart-drawer-section'];
          var sec = document.getElementById('shopify-section-cart-drawer-section');
          if (html && sec) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
            /* tiroir ouvert : on ne remplace que l'interieur de la fenetre, sinon elle se referme */
            var dlg = sec.querySelector('dialog'), freshDlg = fresh && fresh.querySelector('dialog');
            if (dlg && dlg.open && freshDlg) dlg.innerHTML = freshDlg.innerHTML;
            else if (fresh) sec.innerHTML = fresh.innerHTML;
          }
          return _fetch(root + 'cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart && cart.item_count);
          /* panier GRENADINE (identique a l'ancien theme) : on le rafraichit et on l'ouvre apres un ajout */
          if (window.grRefreshCart) return window.grRefreshCart(open).then(function () { return cart; });
          if (open) {
            var drawer = document.querySelector('theme-drawer#cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }
          return cart;
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('gr:cart-updated', { detail: cart }));
          /* apres un ajout : utilise par le pop-up "Avant votre lissage" (snippets/gr-lissage-alerte) */
          if (open) document.dispatchEvent(new CustomEvent('gr:cart-added', { detail: cart }));
        })
        .catch(function () {});
    }, 60);
  }

  function updateCount(n) {
    if (typeof n !== 'number') return;
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      var bubble = icon.querySelector('.cart-bubble, [class*="cart-bubble"], [class*="count"]');
      if (bubble) {
        var txt = bubble.querySelector('[class*="text"], span') || bubble;
        txt.textContent = n > 0 ? String(n) : '';
        bubble.classList.toggle('visually-hidden', n === 0);
        bubble.hidden = n === 0;
      }
    });
  }

  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = _fetch(input, init);
    if (method === 'POST' && isCartMutation(url)) {
      p.then(function (res) { if (res && res.ok) refresh(isAdd(url)); }).catch(function () {});
    }
    return p;
  };

  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__grUrl = u; this.__grMethod = (m || '').toUpperCase(); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (x.__grMethod === 'POST' && isCartMutation(x.__grUrl || '')) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) refresh(isAdd(x.__grUrl)); });
    }
    return _send.apply(this, arguments);
  };

  window.__grenadineRefreshCartDrawer = function (open) { refresh(open !== false); };
})();

/* "+" des produits recommandes du panier */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-grx-add]'); if (!b) return;
  e.preventDefault(); b.disabled = true;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-grx-add'), quantity: 1 }] }) })
    .finally(function () { b.disabled = false; });
});

/* En-tete GRENADINE (repris de l'ancien theme) : l'icone panier ouvre le tiroir Horizon,
   et les pastilles [data-cart-count] suivent le panier */
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('[data-drawer-toggle="drawer-cart"]'); if (!t) return;
  if (window.grOpenCart) return; /* gere par gro-cart-drawer.js */
  var d = document.querySelector('theme-drawer#cart-drawer');
  if (d && typeof d.open === 'function') { e.preventDefault(); e.stopPropagation(); d.open(); }
}, true);
document.addEventListener('gr:cart-updated', function (e) {
  var n = e.detail && e.detail.item_count;
  if (typeof n !== 'number') return;
  document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('hidden', !n); });
});

/* Voile sombre derriere le tiroir panier (Horizon l'ouvre sans voile) ; clic sur le voile = fermer */
(function () {
  var ov = null;
  function sync() {
    var td = document.querySelector('theme-drawer#cart-drawer'), d = td && td.querySelector('dialog');
    var isOpen = !!(d && d.open);
    if (isOpen && !ov) {
      ov = document.createElement('div'); ov.className = 'gr-cart-ov';
      ov.addEventListener('click', function () { var t = document.querySelector('theme-drawer#cart-drawer'); if (t && typeof t.close === 'function') t.close(); });
      document.body.appendChild(ov);
    } else if (!isOpen && ov) { ov.remove(); ov = null; }
  }
  function start() {
    var sec = document.getElementById('shopify-section-cart-drawer-section'); if (!sec) return;
    new MutationObserver(sync).observe(sec, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Arrivee depuis /cart (redirection, voir sections/gr-cart-redirect.liquid) : ouvrir le tiroir panier */
(function () {
  var go = false;
  try { go = sessionStorage.getItem('grenadine_open_cart_drawer') === '1'; if (go) sessionStorage.removeItem('grenadine_open_cart_drawer'); } catch (e) {}
  if (!go) return;
  var n = 0;
  (function tryOpen() {
    if (window.grOpenCart && document.getElementById('drawer-cart')) { window.grOpenCart(); return; }
    if (++n < 40) setTimeout(tryOpen, 150);
  })();
})();
